import { fg } from '@atlassian/jira-feature-gating';

const RemoveSimilarIssuesFromLinkedIssuesRelayProvider = {
	get(): boolean {
		return fg('flash-896_remove_similar_issues_from_linked_issues');
	},
};

export default RemoveSimilarIssuesFromLinkedIssuesRelayProvider;
